import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import STRING_KEYS from '../../../../language/keys';
import { useAnalyticsContext } from '../../../../contexts/analytics/useAnalyticsContext';
import { ANALYTICS_EVENTS, EVENT_GROUP, PRODUCT_AREA } from '../../../../consts/analytics';
import { PAGE_NAMES } from '../../../../consts/pages';
import { useGetPositionSequencePreferencesSelector } from '../../../../store/rtk-query/apis/sequence/selectors/position-sequence-preferences.selector';
import { AppRouting } from '../../../../services/appRoutingResolver';
import {
  AnimatedContainer,
  ConversationsEmptyPage,
  OutreachDescription,
  OutreachIcon,
  OutreachTitle,
} from './conversation-empty.styled';

const ConversationEmpty = (): JSX.Element | null => {
  const { t: translate } = useTranslation();
  const { analyticsPageEvent } = useAnalyticsContext();
  const { positionId } = useParams<MatchUrlParams>();

  const {
    data: preferences,
    isSuccess: isGetPreferencesSuccess,
  } = useGetPositionSequencePreferencesSelector(positionId);

  useEffect(() => {
    analyticsPageEvent({
      eventName: ANALYTICS_EVENTS.OUTREACH_EMPTY_PAGE_VIEW,
      pageName: PAGE_NAMES.TALENT_OUTREACH_EMPTY,
      eventGroup: EVENT_GROUP.PAGE_VIEW,
      productArea: PRODUCT_AREA.TALENT_OUTREACH,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderTitle = () => {
    return (
      <>
        <span>{translate(STRING_KEYS.OUTREACH_PAGE.EMPTY_CONVERSATION.TITLE_LABEL)}</span>
        <span>{translate(STRING_KEYS.OUTREACH_PAGE.EMPTY_CONVERSATION.TITLE)}</span>
      </>
    );
  };

  const renderDescription = () => {
    return translate(STRING_KEYS.OUTREACH_PAGE.EMPTY_CONVERSATION.DESCRIPTION);
  };

  if (isGetPreferencesSuccess && !preferences?.contentPreferences) {
    return <Redirect to={ AppRouting.buildPositionContentPreferencesPageUrl(positionId) } />;
  }

  return (
    <ConversationsEmptyPage>
      <AnimatedContainer>
        <OutreachIcon />
        <OutreachTitle>{ renderTitle() }</OutreachTitle>
        <OutreachDescription>{ renderDescription() }</OutreachDescription>
      </AnimatedContainer>
    </ConversationsEmptyPage>
  );
};

export default ConversationEmpty;
